import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { InvoicesAndReceiptsWidgetComponent } from './containers/invoices-and-receipts-widget.component';
import { DebtorAddressSectionComponent } from './components/debtor-address-section/debtor-address-section.component';
import { BankAccountDetailsComponent } from './components/bank-account-details/bank-account-details.component';
import { TitleComponent } from './components/title/title.component';
import { PremisesSectionComponent } from './components/premises-section/premises-section.component';
import { InvoiceApplicationPrintLayoutComponent } from './components/invoice-application-print-layout.component';
import { RightBoxAddressSectionComponent } from './components/right-box-address-section/right-box-address-section.component';
import { DebtorAccountNoComponent } from './components/debtor-account-no/debtor-account-no.component';
import { InvoiceApplicationTotalSummaryComponent } from './components/invoice-application-total-summary/invoice-application-total-summary.component';
import { InvoiceItemsComponent } from './components/invoice-items/invoice-items.component';
import { TaxReceiptTotalSummaryComponent } from './components/tax-receipt-total-summary/tax-receipt-total-summary.component';
import { TaxReceiptPrintLayoutComponent } from './components/tax-receipt-print-layout.component';
import { TaxReceiptItemsComponent } from './components/tax-receipt-items/tax-receipt-items.component';

@NgModule({
    declarations: [
        InvoicesAndReceiptsWidgetComponent,
        DebtorAddressSectionComponent,
        BankAccountDetailsComponent,
        TitleComponent,
        PremisesSectionComponent,
        InvoiceApplicationPrintLayoutComponent,
        RightBoxAddressSectionComponent,
        DebtorAccountNoComponent,
        InvoiceApplicationTotalSummaryComponent,
        InvoiceItemsComponent,
        TaxReceiptTotalSummaryComponent,
        TaxReceiptPrintLayoutComponent,
        TaxReceiptItemsComponent
      ],
    exports: [
        InvoicesAndReceiptsWidgetComponent,
        DebtorAddressSectionComponent,
        BankAccountDetailsComponent,
        TitleComponent,
        PremisesSectionComponent,
        InvoiceApplicationPrintLayoutComponent,
        TaxReceiptPrintLayoutComponent
      ],
    imports: [
      CommonModule,
      SharedModule
    ],
    providers: []
  })
  
  export class InvoicesAndReceiptsWidgetModule { }
